import type {
	EventLogFromSocket,
	EventLogV2Payload,
	EventsLogRequest,
	EventsLogResultData,
} from 'src/types/requests/eventslog/events_log';

export { isEventLogV2Enabled } from 'src/stores/event_log_v2_enabled';
import { isEventLogV2Enabled } from 'src/stores/event_log_v2_enabled';

export const buildEventsLogRequest = (
	tags: string[],
	limit: number,
	pointer?: string,
): EventsLogRequest => {
	const payload: EventsLogRequest = pointer ? { pointer } : { tags };
	if (isEventLogV2Enabled()) {
		payload.v2 = true;
	}
	payload.limit = limit;
	return payload;
};

export const parseEventLogPayload = (payload: EventsLogResultData['p']): unknown => {
	if (typeof payload === 'string') {
		try {
			return JSON.parse(payload);
		} catch {
			return null;
		}
	}
	return payload;
};

export const isEventLogV2Payload = (payload: unknown): payload is EventLogV2Payload =>
	payload !== null && typeof payload === 'object' && !Array.isArray(payload);

export const getSocketEventDeviceId = (
	socketPayload: EventLogFromSocket['p'],
	fallbackTag?: string | number,
): string | number | undefined => {
	if (Array.isArray(socketPayload)) {
		return socketPayload[0] as string | number;
	}
	return fallbackTag;
};

export const matchesEventLogChannel = (
	channelFilter: string | number | null,
	payload: unknown[],
): boolean => {
	if (!channelFilter) {
		return true;
	}
	const channelFromPayload = payload[1];
	return typeof channelFromPayload !== 'number' || channelFilter == String(channelFromPayload);
};
